import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { LocalStorageHelper } from '../../../core/helpers/local-storage.helper';

@Component({
  selector: 'app-forget-password',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ToastModule],
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss',
})
export class ForgetPasswordComponent implements OnInit {
  userEmail: string = '';

  constructor(
    private _router: Router,
    private _authServices: AuthService,
    private messageService: MessageService,
    private localStorage: LocalStorageHelper
  ) {}

  ngOnInit(): void {}

  getOTPcode() {
    if (this.userEmail && this.userEmail.trim() !== '') {
      const email = this.userEmail.trim();
      this._authServices.forgetPassword(email).subscribe({
        next: (result: any) => {
          if (result && result.success) {
            this.localStorage.setItem('userEmail', email);
            this.localStorage.setItem('otpPurpose', 'forgot_password');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: result.message || result.Message || 'OTP sent successfully!'
            });
            this._router.navigate(['/verify-otp']);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: result?.message || result?.Message || 'Failed to send OTP'
            });
          }
        },
        error: (error: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.error?.message || error.error?.Message || 'Failed to send OTP'
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please enter email'
      });
    }
  }
}
